import React from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../components/layout/Logo";
import NewsLetter from "./NewsLetter";
import './Footer.css';
import { useLocation } from "react-router-dom";
const year = new Date().getFullYear();

const Footer = () => {
  const location = useLocation();

  const isCoursesLiveView = location.pathname === "/courses-live-view";
  return (
    <section>
     
       
          {/* Newsletter Section */}

          {!isCoursesLiveView && <NewsLetter />}

          {/* Navigation Section */}
          <div className="footer__nav">
            <div className="footer__nav-single">
              <div className="footer__nav-title">
                <Logo color="white" />
              </div>
              <ul className="footer__nav__menu">
                <li>
                  <NavLink to="/cookie" className="footer__nav__menu-link">
                    COOKIE POLICY
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/privacy"
                    className="footer__nav__menu-link"
                  >
                    PRIVACY POLICY
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/legal" className="footer__nav__menu-link">
                    TERMS & CONDITIONS
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/faq" className="footer__nav__menu-link">
                    FAQ’s
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>

          {/* Copyright Section */}
          <div className="copyright">
            <div className="copyright-text">
              © {year} - Timely Golf - Site Designed By{" "}
              <a
                href="https://itswronit.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="text-ops-rg-16-wt">Wronit</span>
              </a>
            </div>
          </div>
       
     
    </section>
  );
};

export default Footer;
